import axios from 'axios';
// 创建 axios 实例
const httpMul = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_CREATE,
    timeout: 0, // 无超时限制，一直等待响应
});
export default httpMul;
